import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import * as config from "@/config";

// import StationPcm from '@views/station/StationPcm.vue'

const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location: any) {
  const call: any = originalPush.call(this, location);

  return call.catch((err: any) => err);
};
Vue.use(VueRouter);
export const asyncRouterMap = [];
// 总的路由
const allRouterMap = [
  {
    path: "*",
    redirect: "/kunming/home",
    meta: {
      isKunMing: true,
    },
  },
  {
    path: "*",
    redirect: "/pcm/homePage", //    /pcm/home
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@views/admin/Login.vue"),
  },
  {
    path: "/regist",
    name: "Regist",
    component: () => import("@views/admin/Regist.vue"),
  },
  {
    path: "/",
    redirect: "/kunming/home",
    meta: {
      isKunMing: true,
    },
  },
  {
    path: "/",
    redirect: "/pcm/homePage",
    meta: {
      isHome: true,
    },
  },
  {
    path: "/temp",
    name: "temp",
    meta: {
      isKunMing: false,
    },
    component: () => import("@views/station/StationTemp.vue"),
    redirect: "/kunming/home",
    children: [
      {
        path: "home",
        name: "tempHome",
        component: () => import("@views/temp/Home.vue"),
      },
    ],
  },
  {
    path: "/kunming",
    meta: {
      isKunMing: true,
    },
    component: () => import("@views/station/StationKunMing.vue"),
    redirect: "/kunming/home",
    children: [
      {
        path: "home",
        name: "KunMingHome",
        component: () => import("@views/kunming/Home.vue"),
      },
      {
        path: "apply",
        name: "KunMingApply",
        component: () => import("@views/kunming/Apply.vue"),
      },
      {
        path: "policy",
        name: "KunMingPolicy",
        component: () => import("@views/kunming/Policy.vue"),
      },
      // {
      //   path: 'list',
      //   name: 'PcmList',
      //   component: () => import('@views/pcm/List.vue'),
      // },
    ],
  },
  {
    path: "/pcm",
    component: () => import("@views/station/StationPcm.vue"),
    redirect: "/pcm/homePage",
    children: [
      {
        path: "matchResult",
        name: "pcmMatchResult",
        meta: {
          keepAlive: true,
        },
        component: () => import("@views/pcm/matchResult.vue"),
      },
      {
        path: "newList",
        name: "pcmNewList",
        meta: {
          keepAlive: true,
        },
        component: () => import("@views/pcm/newList.vue"),
      },
      {
        path: "tax",
        name: "pcmTax",
        meta: {
          keepAlive: true,
        },
        component: () => import("@views/pcm/Tax.vue"),
      },
      {
        path: "productSale",
        name: "pcmProductSale",
        meta: {
          keepAlive: true,
        },
        component: () => import("@views/pcm/ProductSale.vue"),
      },
      {
        path: "verify",
        name: "pcmVerify",
        meta: {
          keepAlive: false,
        },
        component: () => import("@views/pcm/Verify.vue"),
      },
      {
        path: "allpolicy",
        name: "PcmAllpolicy",
        meta: {
          keepAlive: true,
        },
        component: () => import("@views/pcm/AllPolicy.vue"),
      },
      {
        path: "company",
        name: "PcmCompany",
        component: () => import("@views/pcm/Company.vue"),
      },
      {
        path: "home",
        name: "PcmHome",
        meta: {
          keepAlive: true,
        },
        component: () => import("@views/pcm/Home.vue"),
      },
      {
        path: "homePage",
        name: "PcmHomePage",
        meta: {
          keepAlive: true,
        },
        component: () => import("@views/pcm/HomePage.vue"),
      },
      {
        path: "apply",
        name: "PcmApply",
        meta: {
          keepAlive: true,
        },
        component: () => import("@views/pcm/Apply.vue"),
      },
      {
        path: "noApply",
        name: "PcmNoApply",
        meta: {
          keepAlive: false,
        },
        component: () => import("@views/pcm/NoApply.vue"),
      },
      {
        path: "publicy",
        name: "PcmPublicy",
        meta: {
          keepAlive: true,
        },
        component: () => import("@views/pcm/Publicy.vue"),
      },
      {
        path: "market",
        name: "PcmMarket",
        meta: {
          keepAlive: true,
        },
        component: () => import("@views/pcm/Market.vue"),
      },
      {
        path: "media",
        name: "PcmMedia",
        meta: {
          keepAlive: false,
        },
        component: () => import("@views/pcm/Media.vue"),
      },
      {
        path: "tool",
        name: "PcmTool",
        meta: {
          keepAlive: true,
        },
        component: () => import("@views/pcm/toolList.vue"),
      },
      {
        path: "inform",
        name: "PcmInform",
        meta: {
          keepAlive: true,
        },
        component: () => import("@views/pcm/Inform.vue"),
      },
      {
        path: "policy",
        name: "PcmPolicy",
        meta: {
          keepAlive: true,
        },
        component: () => import("@views/pcm/Policy.vue"),
      },
      {
        path: "appeal",
        name: "PcmAppeal",
        meta: {
          keepAlive: true,
        },
        component: () => import("@views/pcm/Appeal.vue"),
      },
      {
        path: "GHpolicy_a",
        name: "qjGHpolicy_a",
        meta: {
          keepAlive: true,
        },
        component: () => import("@views/pcm/GHpolicy_a.vue"),
      },
      {
        path: "GHpolicy_b",
        name: "qjGHpolicy_b",
        meta: {
          keepAlive: true,
        },
        component: () => import("@views/pcm/GHpolicy_b.vue"),
      },
      {
        path: "expendpolicy_a",
        name: "qjExpendpolicy_a",
        meta: {
          keepAlive: true,
        },
        component: () => import("@views/pcm/Expendpolicy_a.vue"),
      },
      {
        path: "expendpolicy_b",
        name: "qjExpendpolicy_b",
        meta: {
          keepAlive: true,
        },
        component: () => import("@views/pcm/Expendpolicy_b.vue"),
      },
      {
        path: "expendpolicy_c",
        name: "qjExpendpolicy_c",
        meta: {
          keepAlive: true,
        },
        component: () => import("@views/pcm/Expendpolicy_c.vue"),
      },
      {
        path: "expendpolicy_d",
        name: "qjExpendpolicy_d",
        meta: {
          keepAlive: true,
        },
        component: () => import("@views/pcm/Expendpolicy_d.vue"),
      },
      {
        path: "expendpolicy_e",
        name: "qjExpendpolicy_e",
        meta: {
          keepAlive: true,
        },
        component: () => import("@views/pcm/Expendpolicy_e.vue"),
      },
      {
        path: "expendpolicy_f",
        name: "qjExpendpolicy_f",
        meta: {
          keepAlive: true,
        },
        component: () => import("@views/pcm/Expendpolicy_f.vue"),
      },
      {
        path: "policyDetail",
        name: "DetailPolicy",
        // meta: {
        //   keepAlive: true,
        // },
        component: () => import("@views/detail/Policy.vue"),
      },
      {
        path: "online",
        name: "PcmList",
        meta: {
          keepAlive: true,
        },
        component: () => import("@views/pcm/online.vue"),
      },
      // {
      //   path: "exemptReview",
      //   name: "PcmExemptReview",
      //   meta: {
      //     keepAlive: true,
      //   },
      //   component: () => import("@views/pcm/ExemptReview.vue"),
      // },
      {
        path: "erDetails",
        name: "ErDetails",
        meta: {
          keepAlive: false,
        },
        component: () => import("@views/pcm/ErDetails.vue"),
      },
      {
        path: "erResult",
        name: "ErResult",
        meta: {
          keepAlive: false,
        },
        component: () => import("@views/pcm/ErResult.vue"),
      },
      // 政策匹配报告
      {
        path: "policyreport",
        name: "policyreport",
        meta: {
          keepAlive: true,
        },
        component: () => import("@views/pcm/policyreport.vue"),
      },
    ],
  },
  {
    path: "/person",
    component: () => import("@views/station/StationCenter.vue"),
    redirect: "/person/home",
    children: [
      {
        path: "information",
        name: "PersonInformation",
        meta: {
          keepAlive: true,
        },
        component: () => import("@views/center/Information.vue"),
      },
      {
        path: "NoApply",
        name: "UnitNoApply",
        meta: {
          keepAlive: true,
        },
        component: () => import("@views/center/NoApply.vue"),
      },
      {
        path: "match",
        name: "PersonMatch",
        meta: {
          keepAlive: true,
        },
        component: () => import("@views/center/Match.vue"),
      },
      {
        path: "subscribe",
        name: "PersonSubscribe",

        component: () => import("@views/center/Subscribe.vue"),
      },
      {
        path: "subscribelist",
        name: "PersonSubscribeList",

        component: () => import("@views/center/SubscribeList.vue"),
      },
      {
        path: "home",
        name: "PersonHome",
        meta: {
          keepAlive: true,
        },
        component: () => import("@views/center/Home.vue"),
      },
      {
        path: "basic",
        name: "PersonBasic",
        meta: {
          keepAlive: true,
        },
        component: () => import("@views/center/PersonBasic.vue"),
      },
      {
        path: "setting",
        name: "PersonSetting",
        meta: {
          keepAlive: true,
        },
        component: () => import("@views/center/Setting.vue"),
      },
      {
        path: "companyFill",
        name: "CompanyFill",
        meta: {
          keepAlive: true,
        },
        component: () => import("@views/center/companyFill.vue"),
      },
      {
        path: "order",
        name: "PersonOrder",
        meta: {
          keepAlive: true,
        },
        component: () => import("../views/center/Order.vue"),
      },
      {
        path: "pro",
        name: "PersonPro",
        meta: {
          keepAlive: true,
        },
        component: () => import("../views/center/Pro.vue"),
      },
      {
        path: "apply",
        name: "PersonApply",
        meta: {
          keepAlive: true,
        },
        component: () => import("@views/center/Apply.vue"),
      },
      {
        path: "authern",
        name: "PersonAuthern",
        meta: {
          keepAlive: true,
        },
        component: () => import("@views/center/PersonAuthern.vue"),
      },
    ],
  },
  {
    path: "/declare",
    component: () => import("@views/station/StationCenter.vue"),
    redirect: "/declare/home",
    children: [
      {
        path: "match",
        name: "ApplyMatch",
        meta: {
          keepAlive: true,
        },
        component: () => import("@views/center/Match.vue"),
      },
      {
        path: "NoApply",
        name: "UnitNoApply",
        meta: {
          keepAlive: true,
        },
        component: () => import("@views/center/NoApply.vue"),
      },
      {
        path: "subscribe",
        name: "ApplySubscribe",
        meta: {
          keepAlive: true,
        },
        component: () => import("@views/center/Subscribe.vue"),
      },
      {
        path: "subscribelist",
        name: "ApplySubscribeList",
        meta: {
          keepAlive: true,
        },
        component: () => import("@views/center/SubscribeList.vue"),
      },
      {
        path: "home",
        name: "ApplyHome",
        meta: {
          keepAlive: true,
        },
        component: () => import("@views/center/Home.vue"),
      },
      {
        path: "apply",
        name: "ApplyApply",
        meta: {
          keepAlive: true,
        },
        component: () => import("@views/center/Apply.vue"),
      },
      {
        path: "setting",
        name: "ApplySetting",
        meta: {
          keepAlive: true,
        },
        component: () => import("@views/center/Setting.vue"),
      },
      {
        path: "companyFill",
        name: "CompanyFill",
        meta: {
          keepAlive: true,
        },
        component: () => import("@views/center/companyFill.vue"),
      },
      {
        path: "pro",
        name: "ApplyPro",
        meta: {
          keepAlive: true,
        },
        component: () => import("../views/center/Pro.vue"),
      },
      {
        path: "order",
        name: "ApplyOrder",
        meta: {
          keepAlive: true,
        },
        component: () => import("../views/center/Order.vue"),
      },
    ],
  },
  {
    path: "/unit",
    component: () => import("@views/station/StationCenter.vue"),
    redirect: "/unit/home",
    children: [
      {
        path: "calculate",
        name: "UniCalculate",
        meta: {
          keepAlive: true,
        },
        component: () => import("@views/center/Calculate.vue"),
      },
      {
        path: "match",
        name: "UnitMatch",
        meta: {
          keepAlive: true,
        },
        component: () => import("@views/center/Match.vue"),
      },
      {
        path: "subscribe",
        name: "UnitSubscribe",
        meta: {
          keepAlive: true,
        },
        component: () => import("@views/center/Subscribe.vue"),
      },
      {
        path: "subscribelist",
        name: "UnitSubscribeList",
        meta: {
          keepAlive: true,
        },
        component: () => import("@views/center/SubscribeList.vue"),
      },
      {
        path: "collectionListlist",
        name: "UnitCollectionListList",
        meta: {
          keepAlive: true,
        },
        component: () => import("@views/center/CollectionList.vue"),
      },
      {
        path: "appeal",
        name: "UnitAppeal",
        meta: {
          keepAlive: true,
        },
        component: () => import("@views/center/appeal.vue"),
      },
      {
        path: "home",
        name: "UnitHome",
        meta: {
          keepAlive: true,
        },
        component: () => import("@views/center/Home.vue"),
      },
      {
        path: "order",
        name: "UnitOrder",
        meta: {
          keepAlive: true,
        },
        component: () => import("../views/center/Order.vue"),
      },
      {
        path: "NoApply",
        name: "UnitNoApply",
        meta: {
          keepAlive: true,
        },
        component: () => import("@views/center/NoApply.vue"),
      },
      {
        path: "ApplyNo",
        name: "ApplyNo",
        meta: {
          keepAlive: true,
        },
        component: () => import("@views/center/ApplyNo.vue"),
      },
      {
        path: "ApplyNo_det",
        name: "ApplyNo_det",
        component: () => import("@views/center/ApplyNo_det.vue"),
      },
      {
        path: "ApplyNo_dets",
        name: "ApplyNo_dets",
        component: () => import("@views/center/ApplyNo_dets.vue"),
      },
      {
        path: "apply",
        name: "UnitApply",
        meta: {
          keepAlive: true,
        },
        component: () => import("@views/center/Apply.vue"),
      },
      {
        path: "declarePage",
        name: "declarePage",
        meta: {
          keepAlive: true,
        },
        component: () => import("@views/center/declarePage.vue"),
      },
      {
        path: "declareDetail",
        name: "declareDetail",
        meta: {
          keepAlive: true,
        },
        component: () => import("@views/center/declareDetail.vue"),
      },
      {
        path: "pro",
        name: "UnitPro",
        meta: {
          keepAlive: true,
        },
        component: () => import("@views/center/Pro.vue"),
      },
      {
        path: "setting",
        name: "UnitSetting",
        meta: {
          keepAlive: true,
        },
        component: () => import("@views/center/Setting.vue"),
      },
      {
        path: "companyFill",
        name: "CompanyFill",
        meta: {
          keepAlive: true,
        },
        component: () => import("@views/center/companyFill.vue"),
      },
      {
        path: "authern",
        name: "UnitAuthern",
        meta: {
          keepAlive: true,
        },
        component: () => import("@views/center/UnitAuthern.vue"),
      },
      {
        path: "extraBasic",
        name: "UnitExtraBasic",
        meta: {
          keepAlive: true,
        },
        component: () => import("@views/center/UnitExtraBasic.vue"),
      },
      {
        path: "basic",
        name: "UnitBasic",
        meta: {
          keepAlive: true,
        },
        component: () => import("@views/center/UnitBasic.vue"),
      },
      {
        path: "applicant",
        name: "Applicant",
        meta: {
          keepAlive: true,
        },
        component: () => import("@views/center/Applicant.vue"),
      },
    ],
  },
  {
    path: "/detail",
    component: () => import("@views/station/StationPcm.vue"),
    redirect: "/pcm/home",
    children: [
      {
        path: "match",
        name: "DetailMatch",
        component: () => import("@views/detail/Match.vue"),
      },
      {
        path: "noApply/:id",
        name: "DetailNoApply",
        component: () => import("@views/detail/NoApply.vue"),
      },
      {
        path: "text",
        name: "DetailText",
        component: () => import("@views/detail/Text.vue"),
      },
      {
        path: "img",
        name: "DetailImg",
        component: () => import("@views/detail/Img.vue"),
      },
      {
        path: "apply",
        name: "DetailApply",
        component: () => import("@views/detail/Apply.vue"),
      },
      {
        path: "applybtn",
        name: "DetailApplyBtn",
        component: () => import("@views/detail/ApplyBtn.vue"),
      },
      {
        path: "reportdeclare",
        name: "DetailReportDeclare",
        component: () => import("@views/detail/ReportDeclare.vue"),
      },
      {
        path: "declare",
        name: "DetailDeclare",
        component: () => import("@views/detail/Declare.vue"),
      },
      {
        path: "policy",
        name: "DetailPolicy",
        component: () => import("@views/detail/Policy.vue"),
      },
      {
        path: "inform",
        name: "DetailInform",
        component: () => import("@views/detail/Inform.vue"),
      },
      {
        path: "publicy",
        name: "DetailPublicy",
        component: () => import("@views/detail/Publicy.vue"),
      },
      {
        path: "msg",
        name: "DetailMsg",
        component: () => import("@views/detail/Msg.vue"),
      },
      {
        path: "market",
        name: "DetailMarket",
        component: () => import("@views/detail/Market.vue"),
      },
	  // 政策指南
	  {
	    path: "policyGuidelines",
	    name: "policyGuidelines",
	    component: () => import("@views/detail/PolicyGuidelines.vue"),
	  },
    ],
  },
  {
    path: "/kunmingdetail",
    component: () => import("@views/station/StationKunMingDetail.vue"),
    meta: {
      isKunMing: true,
    },
    children: [
      {
        path: "company",
        name: "DetailCompany",
        component: () => import("@views/pcm/Company.vue"),
        // children: [
        //   // 政策匹配报告
        //   {
        //     path: "policyreport",
        //     name: "policyreport",
        //     meta: {
        //       keepAlive: true,
        //     },
        //     component: () => import("@views/pcm/policyreport.vue"),
        //   },
        // ],
      },
      {
        path: "match",
        name: "DetailMatch",
        component: () => import("@views/detail/Match.vue"),
      },
      {
        path: "allpolicy",
        name: "DetailAllpolicy",
        component: () => import("@views/pcm/AllPolicy.vue"),
      },
      // {
      //   path: 'text',
      //   name: 'DetailText',
      //   component: () => import('@views/detail/Text.vue'),
      // },
      // {
      //   path: 'img',
      //   name: 'DetailImg',
      //   component: () => import('@views/detail/Img.vue'),
      // },
      {
        path: "apply",
        name: "DetailApply",
        component: () => import("@views/detail/Apply.vue"),
      },
      // {
      //   path: 'apply',
      //   name: 'DetailApply',
      //   component: () => import('@views/detail/Apply.vue'),
      // },
      {
        path: "policy",
        name: "DetailPolicy",
        component: () => import("@views/detail/Policy.vue"),
      },
      // {
      //   path: 'inform',
      //   name: 'DetailInform',
      //   component: () => import('@views/detail/Inform.vue'),
      // },
      // {
      //   path: 'publicy',
      //   name: 'DetailPublicy',
      //   component: () => import('@views/detail/Publicy.vue'),
      // },
      // {
      //   path: 'msg',
      //   name: 'DetailMsg',
      //   component: () => import('@views/detail/Msg.vue'),
      // },
      // {
      //   path: 'market',
      //   name: 'DetailMarket',
      //   component: () => import('@views/detail/Market.vue'),
      // },
    ],
  },
];
// 本地的情况，通过更改network的值,true为昆明,false为全部
const isKunMing: any = (config as any).default.isKunMing;
export const defaultRouterMap = allRouterMap.filter((item: any) => {
  const { meta } = item;
  if (!meta) {
    return !isKunMing;
  } else {
    const { isKunMing: currentIsKunMing } = meta;
    return currentIsKunMing === isKunMing;
  }
});
const formArr = [
  "applicationMaterials",
  "apply",
  "createProject",
  "extraordinaryReceipts",
  "fixedAssets",
  "manpowerZY",
  "projectapproval",
  "statistics",
  "TechnicalIncome",
  "ThatReview",
  "ChinaHighApply",
  "GHpolicy_a",
  "GHpolicy_b",
  "expenditurePersonnel",
  "ChinaHighRegistrationForm",
  "specializationRegistration",
  "specializationBenefit",
  "specializationProfessionalization",
  "specializationInnovationCapacity",
  "specializationManagement",
  "specializationDatagenerated",
];
const formRoutes: any = [
  {
    path: "/centerForm",
    component: () => import("@views/station/StationCenter.vue"),
    redirect: "/centerForm/createProject",
    children: [
      {
        path: "match",
        name: "ApplyMatch",
        meta: {
          keepAlive: true,
        },
        component: () => import("@views/center/Match.vue"),
      },
    ],
  },
];
function toUpper(str: any) {
  return str.slice(0, 1).toUpperCase() + str.slice(1).toLowerCase();
}
formRoutes[0].children = formArr.map((name: any) => {
  return {
    path: name,
    name: `Center${toUpper(name)}`,
    component: () => import(`@views/form/${name}/index.vue`),
  };
});
// const routes: Array<RouteConfig> = [
//   {
//     path: "/",
//     name: "Home",
//     component: () => import('@views/user/Station.vue'),
//   },
// ];

export default new VueRouter({ routes: defaultRouterMap.concat(formRoutes) });
